export function getFallbackCenterCoordinates(): { lat: number; lng: number } {
  return { lat: 39.4389059, lng: -97.6547145 };
}
